/* Velvet Bunny — vanilla JS. One init per component, all guarded. */
(function () {
  'use strict';

  if (window.__mtInit) return;
  window.__mtInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll reveal (shared observer) ---- */
  function initReveal() {
    var els = Array.prototype.slice.call(document.querySelectorAll('.mt-reveal'));
    if (!els.length) return;
    function reveal(el) {
      if (el.classList.contains('mt-visible')) return;
      var delay = el.getAttribute('data-mt-delay') || 0;
      el.style.transitionDelay = delay + 'ms';
      el.classList.add('mt-visible');
    }
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(reveal);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { reveal(entry.target); io.unobserve(entry.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -5% 0px' });

    var vh = window.innerHeight || 800;
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top < vh * 0.92) { reveal(el); } // above the fold: show now
      else { io.observe(el); }                                        // below: animate on scroll
    });

    // --- Bulletproof fallbacks: content can NEVER stay hidden ---
    function revealInView() {
      var h = window.innerHeight || vh;
      els.forEach(function (el) {
        if (!el.classList.contains('mt-visible') && el.getBoundingClientRect().top < h + 80) reveal(el);
      });
    }
    window.addEventListener('scroll', revealInView, { passive: true });
    window.addEventListener('resize', revealInView);
    document.addEventListener('visibilitychange', revealInView);
    revealInView();
    // Ultimate safety net: after 2.5s, reveal everything no matter what
    setTimeout(function () { els.forEach(reveal); }, 2500);
  }

  /* ---- Lazy-image rescue ----
     Native loading="lazy" can stall when an image starts life inside a
     reveal/transform container (its geometry is read while hidden and never
     re-checked). We force-load images ourselves a bit before the viewport,
     with a hard safety net so a photo can NEVER stay blank. */
  function initLazyImages() {
    var imgs = Array.prototype.slice.call(document.querySelectorAll('img[loading="lazy"]'));
    if (!imgs.length) return;
    function load(img) {
      if (img.__mtLoaded) return;
      img.__mtLoaded = true;
      img.loading = 'eager';
      var s = img.getAttribute('src');
      if (s) { img.src = s; } // re-kick a stalled native-lazy image
    }
    if (!('IntersectionObserver' in window)) { imgs.forEach(load); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { load(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '900px 0px 900px 0px', threshold: 0 });
    imgs.forEach(function (img) { io.observe(img); });
    // Safety net: after 3s, make sure nothing is left blank.
    setTimeout(function () { imgs.forEach(load); }, 3000);
  }

  /* ---- FAQ accordion ---- */
  function initFaq() {
    var items = document.querySelectorAll('.mt-faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      var q = item.querySelector('.mt-faq__q');
      var a = item.querySelector('.mt-faq__a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        item.classList.toggle('is-open', !open);
        q.setAttribute('aria-expanded', String(!open));
        a.style.maxHeight = open ? '0px' : a.scrollHeight + 'px';
      });
    });
  }

  /* ---- Mobile nav ---- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-mt-burger]');
    var drawer = document.querySelector('.mt-mobnav');
    if (!toggle || !drawer) return;
    var closeEls = drawer.querySelectorAll('[data-mt-close], .mt-mobnav__panel a');
    function open() { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { drawer.classList.remove('is-open'); document.body.style.overflow = ''; }
    toggle.addEventListener('click', open);
    drawer.addEventListener('click', function (e) { if (e.target === drawer) close(); });
    closeEls.forEach(function (el) { el.addEventListener('click', close); });
  }

  /* ---- Smooth scroll for in-page anchors ---- */
  function initAnchors() {
    document.querySelectorAll('a[href^="#mt-"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ---- Product page ---- */
  function initPdp() {
    var root = document.querySelector('[data-mt-pdp]');
    if (!root) return;

    /* Gallery thumbs + dots */
    var mainImg = root.querySelector('[data-mt-main-img]');
    var thumbs = root.querySelectorAll('[data-mt-thumb]');
    var dots = root.querySelectorAll('[data-mt-dot]');
    function base(u) { return (u || '').split('?')[0].split('/').pop(); }
    function sameImg(a, b) { return a && b && base(a) === base(b); }
    var trackEl = root.querySelector('[data-mt-thumbtrack]');
    function setActiveImage(full) {
      if (mainImg && full) { mainImg.src = full; }
      var activeThumb = null;
      thumbs.forEach(function (x) {
        var on = sameImg(x.getAttribute('data-full'), full);
        x.classList.toggle('is-active', on);
        if (on) activeThumb = x;
      });
      dots.forEach(function (d) { d.classList.toggle('is-active', sameImg(d.getAttribute('data-full'), full)); });
      if (activeThumb && trackEl) {
        var off = activeThumb.offsetLeft - (trackEl.clientWidth / 2) + (activeThumb.clientWidth / 2);
        trackEl.scrollTo({ left: Math.max(0, off), behavior: 'smooth' });
      }
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { setActiveImage(t.getAttribute('data-full')); });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { setActiveImage(d.getAttribute('data-full')); });
    });
    // Main image prev/next arrows cycle through all media
    var mediaUrls = Array.from(dots).map(function (d) { return d.getAttribute('data-full'); });
    function cycleMain(dir) {
      if (!mainImg || !mediaUrls.length) return;
      var cur = base(mainImg.currentSrc || mainImg.src);
      var idx = mediaUrls.findIndex(function (u) { return base(u) === cur; });
      if (idx < 0) idx = 0;
      idx = (idx + dir + mediaUrls.length) % mediaUrls.length;
      setActiveImage(mediaUrls[idx]);
    }
    var mainPrev = root.querySelector('[data-mt-mainprev]');
    var mainNext = root.querySelector('[data-mt-mainnext]');
    if (mainPrev) mainPrev.addEventListener('click', function () { cycleMain(-1); });
    if (mainNext) mainNext.addEventListener('click', function () { cycleMain(1); });

    /* Thumbnail scroll arrows */
    var thumbWrap = root.querySelector('[data-mt-thumbwrap]');
    var thumbTrack = root.querySelector('[data-mt-thumbtrack]');
    var thumbPrev = root.querySelector('[data-mt-thumbprev]');
    var thumbNext = root.querySelector('[data-mt-thumbnext]');
    if (thumbWrap && thumbTrack) {
      var checkOverflow = function () {
        thumbWrap.classList.toggle('has-overflow', thumbTrack.scrollWidth > thumbTrack.clientWidth + 4);
      };
      checkOverflow();
      setTimeout(checkOverflow, 400);
      window.addEventListener('resize', checkOverflow);
      if (thumbPrev) thumbPrev.addEventListener('click', function () { thumbTrack.scrollBy({ left: -220, behavior: 'smooth' }); });
      if (thumbNext) thumbNext.addEventListener('click', function () { thumbTrack.scrollBy({ left: 220, behavior: 'smooth' }); });
    }

    /* Variant selection */
    var dataEl = root.querySelector('[data-mt-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    var optionInputs = root.querySelectorAll('[data-mt-option]');
    var idInput = root.querySelector('[data-mt-variant-id]');
    var priceNow = root.querySelector('[data-mt-price-now]');
    var priceWas = root.querySelector('[data-mt-price-was]');
    var priceSave = root.querySelector('[data-mt-price-save]');
    var addBtn = root.querySelector('[data-mt-add]');
    var selNames = root.querySelectorAll('[data-mt-selected-name]');

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function currentSelections() {
      var sel = {};
      optionInputs.forEach(function (inp) {
        if (inp.type === 'radio') {
          if (inp.checked) sel[inp.getAttribute('data-mt-option')] = inp.value;
        } else {
          sel[inp.getAttribute('data-mt-option')] = inp.value;
        }
      });
      return sel;
    }

    function matchVariant() {
      var sel = currentSelections();
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          var name = v.optionNames[i];
          return sel[name] === opt;
        });
      });
    }

    function update() {
      var v = matchVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = money(v.price);
      if (priceWas) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceWas.textContent = money(v.compare_at_price);
          priceWas.style.display = '';
          if (priceSave) {
            var pct = Math.round((1 - v.price / v.compare_at_price) * 100);
            priceSave.textContent = '-' + pct + '%';
            priceSave.style.display = '';
          }
        } else {
          priceWas.style.display = 'none';
          if (priceSave) priceSave.style.display = 'none';
        }
      }
      if (selNames && selNames.length) {
        var selMap = currentSelections();
        selNames.forEach(function (el) {
          var on = el.getAttribute('data-opt-name');
          if (on && selMap[on] != null) { el.textContent = selMap[on]; }
          else { el.textContent = v.title; }
        });
      }
      if (v.image) { setActiveImage(v.image); }
      if (addBtn) {
        if (v.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.getAttribute('data-label-add') || 'Add to cart';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.getAttribute('data-label-sold') || 'Sold out';
        }
      }
    }

    optionInputs.forEach(function (inp) { inp.addEventListener('change', update); });
    update();

    /* Quantity */
    var qtyWrap = root.querySelector('[data-mt-qty]');
    if (qtyWrap) {
      var input = qtyWrap.querySelector('input');
      qtyWrap.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = parseInt(b.getAttribute('data-step'), 10) || 0;
          var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = val;
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initLazyImages();
    initFaq();
    initMobileNav();
    initAnchors();
    initPdp();
  });
})();
